import {IS_CLIENT} from '@/constants/env'
import {getWxCofig} from '@/service/activity'

type WxSharePayload = {
    title?: string
    desc?: string
    link?: string
    imgUrl?: string
}
const initWxConfig = (payload:WxSharePayload = {}, callback?:(data?: any)=>void) => {
    if (IS_CLIENT) {
        const wx = require('weixin-js-sdk')
        const ua = window.navigator.userAgent.toLowerCase()
        if (ua.match(/MicroMessenger/i)?.[0] === 'micromessenger') {
            let params
            params = {url: location.href.split('#')[0]}
            getWxCofig(params).then((res) => {
                if (res && res.code === 0) {
                    const data = res.data
                    if (data) {
                        const jsApiList = [
                            'onMenuShareTimeline',
                            'onMenuShareAppMessage',
                            'checkJsApi',
                            'openAddress',
                            'editAddress',
                            'updateAppMessageShareData',
                            'updateTimelineShareData',
                        ]
                        const params = {
                            debug: false,
                            appId: data.appId,
                            timestamp: data.timestamp,
                            nonceStr: data.nonceStr,
                            signature: data.signature,
                            jsApiList,
                            openTagList: ['wx-open-launch-app', 'wx-open-launch-weapp'],
                        }
                        wx.config(params)

                        const shareData = {
                            title: payload.title || '高途',
                            desc: payload.desc || '名师出高途',
                            link: payload.link || location.href,
                            imgUrl: payload.imgUrl,
                        }
                        wx.ready(() => {
                            console.log('wx.ready')
                            wx.updateAppMessageShareData({
                                ...shareData,
                                success: () => {
                                    console.log('设置微信分享朋友信息成功')
                                }, fail: (error: any) => {
                                    console.log('设置微信分享朋友圈信息失败')
                                    console.log(error)
                                }})
                            wx.updateTimelineShareData({
                                ...shareData,
                                success: () => {
                                    console.log('设置微信分享朋友圈信息成功')
                                }, fail: (error: any) => {
                                    console.log('设置微信分享朋友圈信息失败')
                                    console.log(error)
                                },
                            })
                        })
                        // eslint-disable-next-line callback-return
                        callback && callback(data)
                    }
                }
            })
        }
    }

}
export default initWxConfig
